import { Component, Input, OnDestroy, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LoanProgram }from '../loanprogram.model';
import { Product } from '../product.model';
import { LoanProgramService } from '../loanprogram.service';
import { OrderByField } from '../../users/user-details/orderByField.pipe';
import {ProgramsEditComponent} from '../programs-edit/programs-edit.component';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.css']
})
export class ProgramsComponent implements OnInit {
  @Input()
  public program: LoanProgram;
  public productsInProgram: Product[] = [];
  showProducts: boolean;

  constructor(private loanProgramService: LoanProgramService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.loanProgramService.programUpdated
      .subscribe((program: LoanProgram) => {
        this.productsInProgram = [];
        this.showProducts = false;
      });
  }

  private editProgram(event) {
    this.dialog.open(ProgramsEditComponent, {
        data: this.program,
        height: "510px",
        width: "610px",
        panelClass:"edit-program-dialog"
    }); 
  }

  private deleteProgram(program: LoanProgram) {
    if (confirm('Are you sure you want to delete ' + program.name + '?')) {
      this.loanProgramService.deleteProgram(program.id)
        .then(success => {
          if (!success)
            confirm('There was an error processing your request.');
        })
        .catch(error => {
          confirm('There was an error processing your request.');
        });
    }
  }

  click() {
    if (this.productsInProgram.length === 0) {
      this.getProducts();
    } else {
      this.showProducts = !this.showProducts;
    }
  }

  getProducts() {
    this.loanProgramService.getProducts(this.program.id)
      .then(result => {
        this.productsInProgram = result;
      })
      .catch(error => console.log(error));
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/programs/programs.component.ts